import React, { useEffect, useState } from "react";
import "./verify.style.scss";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Card } from "antd";
import "antd/dist/antd.css";
import { post, responseValidator } from "../../../../api";
import { toast } from "react-toastify";
import Loading from "../../../../loading/loading.index";

export default function AuthVerification() {
    let _clientToken = "";
    let _status = "";
    const [kycState, setKycState] = useState();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const URL = window.location.toString();

        const queryParametr = URL.split("/")[URL.split("/").length - 1];
        if (queryParametr.split("&").length > 0) {
            _clientToken = queryParametr.split("&")[0];
            _clientToken = _clientToken.replace("?clientToken=", "");
            _status = queryParametr.split("&")[1];
            _status = _status.replace("status=", "");

            if (_status == 1 && _clientToken !== "") {
                setIsLoading(true);
                post(`/User/Kyc/Verify/`, {
                    clientToken: _clientToken,
                    status: _status
                }).then(response => {
                    setIsLoading(false);
                    if (responseValidator(response.status)) {
                        setKycState(response.data.data);
                    } else toast.error(response.data.message);
                });
            }
        }
    }, []);

    if (isLoading) return <Loading />;
    return (
        <div className="tmex-auth-verify">
            <Card>
                <h4 style={{ textAlign: "center", marginBottom: "30px" }}>
                    {_clientToken !== "" ? (
                        <React.Fragment>
                            {" "}
                            عملیات احراز هویت با موفقیت انجام شد.{" "}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            عملیات احراز هویت با موفقیت انجام نشد.
                        </React.Fragment>
                    )}
                </h4>
                <div style={{ textAlign: "center" }}>
                    <div
                        className={`order-verify-page ${
                            _clientToken !== "" ? "success" : "failed"
                        }`}
                    >
                        <Card className="content">
                            {_clientToken !== "" ? (
                                <React.Fragment>
                                    {" "}
                                    <i className="fas fa-check-circle" />
                                    <p>
                                        لطفا منتظر تایید اطلاعات توسط کارشناسان
                                        بمانید.
                                    </p>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <CloseCircleOutlined />
                                    <p>احراز شما با موفقیت انجام نشد </p>
                                </React.Fragment>
                            )}

                            <p
                                onClick={() =>
                                    window.location.replace("/userpanel")
                                }
                                className="order-details-button"
                            >
                                بازگشت
                            </p>
                        </Card>
                    </div>
                </div>
            </Card>
        </div>
    );
}
